import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  Renderer2,
  inject,
  signal,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { TranslocoModule, TranslocoService } from '@jsverse/transloco';
import { Languages } from 'libs/shared/src/constants/languages';
import { SUPPORT_CONTACT, SupportContact } from '@anihis/shared';

@Component({
  selector: 'anihis-terms-of-service',
  standalone: true,
  imports: [CommonModule, RouterModule, TranslocoModule],
  templateUrl: './terms-of-service.component.html',
  styleUrls: ['./terms-of-service.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TermsOfServiceComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private renderer = inject(Renderer2);
  private translocoService = inject(TranslocoService);

  readonly contact: SupportContact = SUPPORT_CONTACT;
  readonly isClientSource = signal(false);
  readonly isVetSource = signal(false);
  readonly theme = signal<'dark' | 'light'>('light');

  ngOnInit(): void {
    const params = this.route.snapshot.queryParamMap;
    const source = params.get('source');
    const theme = params.get('theme') as 'dark' | 'light' | null;

    if (source === 'client' || source === 'veterinarian') {
      this.isClientSource.set(true);
    }
    if (source === 'veterinarian') {
      this.isVetSource.set(true);
    }

    if (theme === 'dark' || theme === 'light') {
      this.theme.set(theme);
    }

    const lang = params.get('lang');
    const supportedLangs = Languages.availableLanguages.map(({ id }) => id);
    if (lang && supportedLangs.includes(lang)) {
      this.translocoService.setActiveLang(lang);
    }

    // Apply theme class to root html element
    const html = document.documentElement;
    this.renderer.removeClass(html, 'dark');
    this.renderer.removeClass(html, 'light');
    this.renderer.addClass(html, this.theme());
  }
}
